const deleteAddDocumentCompanies = {
  toastr: 'Deleted document',
  toastr1: 'The document was successfully deleted.'
};

export default deleteAddDocumentCompanies;
